import { render } from "./WorkloadRecommendingDialog.vue?vue&type=template&id=eca6731a&scoped=true"
import script from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadRecommendingDialog.vue?vue&type=script&lang=js"

import "./WorkloadRecommendingDialog.vue?vue&type=style&index=0&id=eca6731a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca6731a"]])

export default __exports__